import React, { useState } from 'react'
import {
  Col,
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Nav,
  TabContent,
  TabPane,
  NavItem,
  NavLink,
  Row,
} from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import { useFieldArray, useForm,Controller } from "react-hook-form";
import {
    useNavigate,
    useParams
  } from "react-router-dom";
  
import { useFaqCategoriesQuery } from 'services/faq';
import NavTabsItem from 'shared/components/Tabs';

interface IProps {

}

const EditFaqCategory: React.FC<IProps>= () =>{
  const params = useParams();
  let navigate = useNavigate();

  const { data: FaqCategory,isLoading } = useFaqCategoriesQuery.useGetSingle(params.id)

  const [activeTab, setActiveTab] = useState('1');
  const { control, handleSubmit } = useForm();
  const { fields, append } = useFieldArray({
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "faq_categories", // unique name for your Field Array
  });
  React.useEffect(() => {
    if (FaqCategory) {
    FaqCategory.forEach((tm) => {
        append(tm);
      });
    }
  }, [FaqCategory]);
  const onSuccessSubmit = () => {
    toast('Task category updated', {
        duration: 2000,
        position: 'top-center',
        icon: '👍🏻',
      });
    setTimeout(() => {
        navigate(-1)
    }, 1000);
}
  
const {
  mutate: mutateFaqCategoryUpdate,
} = useFaqCategoriesQuery.useUpdate(onSuccessSubmit);
const onSubmit = (data: any) => {
  const { faq_categories } =data
  faq_categories.map(
   (el:any)=>
    {
      delete el['unique_identifier']
    }
  )
  mutateFaqCategoryUpdate(faq_categories)
};

  return (
    <>
    {isLoading ? (
        <div>Loading...</div>
        ) : (
        <Card className="mt-3">
        <Toaster />
        <CardBody>
            <h4 className="header-title">Faq category</h4>
            <Form onSubmit={handleSubmit(onSubmit)}>
            <Nav tabs>
                {fields?.map((i: any, index) => (
                <>
                    <NavItem>
                    <NavLink
                        className={activeTab === `${index + 1}` ? "active" : ""}
                        onClick={function noRefCheck() {
                        setActiveTab(`${index + 1}`);
                        }}
                    >
                        <NavTabsItem item={i}/>
                    </NavLink>
                    </NavItem>
                </>
                ))}
            </Nav>
            <TabContent activeTab={activeTab}>
                {fields?.map((i: any, index) => (
                <TabPane tabId={(index + 1).toString()} key={i.id}>
                    <Row>
                    <Col sm="12">
                        <div>
                        <FormGroup row>
                            <Label for="title" sm={3}>
                            Title
                            </Label>
                            <Col sm={9}>
                                    <Controller
                                        name={`faq_categories.${index}.title`}
                                        control={control}
                                        render={({ field }) => (
                                        <Input {...field} type="text" id="title" />
                                        )}
                                    />
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label for="priority" sm={3}>
                            Priority
                            </Label>
                            <Col sm={9}>
                                    <Controller
                                        name={`faq_categories.${index}.priority`}
                                        control={control}
                                        render={({ field }) => (
                                        <Input {...field} type="number" id="priority" />
                                        )}
                                    />
                            </Col>
                        </FormGroup>
                        </div>
                    </Col>
                    </Row>
                </TabPane>
                ))}
            </TabContent>
            <Button color="primary" type="submit">
                Submit
            </Button>
            </Form>
        </CardBody>
        </Card>
    )}
    </>
  );
}

export default EditFaqCategory